<app-card title="">
  <div title class="flex justify-between content-start items-start">

    <mat-icon (click)="redirectCustomerList()" style="margin-bottom: 6px;">
      <img src="/assets/img/icons/ico.16.arwlft.svg" alt="">
    </mat-icon>
    <h5 style="padding-top: 5px;" class="ucase m-0 text-primaryblue xs:basis-full basis-[81%]" tabindex="0">{{customerName}} <span *ngIf="subDeviceTypeName !== null">({{deviceName}}, {{targetInstallDate}})</span></h5>
    <div class="flex justify-between content-center items-center flex-row">
      <mat-icon (click)="onAllUserPaginateChange()" style="padding-right: 14px; ">
        <img style="padding: 4px;" src="/assets/img/icons/ico.24.scrolltotop.svg" alt="">
      </mat-icon>
    </div>
    <div class="basis-[7%]">
      <button id="btn_cddb_add" (click)="openImportWizardCDDB()" class="btn-light btn-sm add_site"><span> CDDB Add </span></button>
    </div>

    <div class="basis-[11%]">
      <button id="btn_change_device" class="bg-red btn-sm" (click)="openImportWizard()">
        Change Device
      </button>

    </div>

    <mat-form-field floatLabel="never" class="basis-[11%]">
            <mat-select style="margin-top: 0rem !important;" matInput [(value)]="exportFileType" (selectionChange)="downloadFile($event.value)">
        <mat-option [disabled]="true" [value]="0" style="text-align: center; background-color: rgb(202 198 198);"><span style="font-weight: bolder;">Export</span></mat-option>
                <mat-option [value]="1" [disabled]="isLegacyConnectMdlLoading || !legacyConnectMdlFile">
                    {{isLegacyConnectMdlLoading ? 'Loading Parata Connect MDL' : 'Parata Connect MDL'}}
                </mat-option>
        <mat-option [value]="2">Customer Drug XLSX</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <section class="table-section">
    <div class="sticky_search">
      <div class="bg-white" style="padding-bottom: 6px; padding-top: 6px;">
        <div class="flex justify-start content-center items-center xs:flex xs:flex-col sm:flex sm:flex-row">

          <div class="search-wrapper basis-[17%]" style="padding: 9px">
            <div class="search-container">
              <app-icon icon="search" class="icon_search"></app-icon>
              <input class="search-input" appNoHtmlTags inputId="searchcustomers-input" (keyup)="doFilter($event.target.value)" minLengthToSearch="1" placeholder="Search" [ngModel]="searchText" id="search_customers">
              <app-icon icon="clear" *ngIf="searchText.length>0" (click)="doFilter('')" id="data-clear" class="pointer"></app-icon>
            </div>
          </div>

          <div class="project-stuats-div flex justify-between content-start items-start basis-1/5">
            <button id="btn_add" [disabled]="true" class=" btn-sm add_site"> <span>Add</span>  </button>

            <button id="remove_celllocation" [ngClass]="" [disabled]="true" class=" btn-sm add_site">
              <span>Remove</span>
            </button>

            <button id="move_celllocation"
                    [ngClass]=""
                    [disabled]="true"
                    class=" btn-sm add_site">
              Move
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="setup_scroll">
      <mat-tab-group (selectedTabChange)="getCurrentTabSelect($event)">
        <mat-tab label="Analysis({{dataSource.data.length}})">
          <div class="mat-elevation-z8" #TABLE>
            <table mat-table #table [dataSource]="dataSource" id="matTable" matSort>

              <!-- Product ID Column -->
              <ng-container matColumnDef="productId">
                <th [hidden]="!isProductId" mat-header-cell *matHeaderCellDef mat-sort-header> Product ID </th>
                <td [hidden]="!isProductId" mat-cell *matCellDef="let element"> {{element.productID}} </td>
              </ng-container>

              <!--NDC column-->
              <ng-container matColumnDef="ndc">
                <th [hidden]="!isNDC" mat-header-cell *matHeaderCellDef mat-sort-header> NDC </th>
                <td [hidden]="!isNDC" mat-cell *matCellDef="let element"> {{element.ndc}} </td>
              </ng-container>


              <!-- Drug Name Column -->
              <ng-container matColumnDef="drugName">
                <th [hidden]="!isDrugName" mat-header-cell *matHeaderCellDef mat-sort-header>CDDB Drug Name </th>
                <td [hidden]="!isDrugName" mat-cell *matCellDef="let element"> {{element.drugName}} </td>
              </ng-container>
              <!-- Customer Drug Name Column -->
              <ng-container matColumnDef="customerDrugName">
                <th [hidden]="!isCustomerDrugName" mat-header-cell *matHeaderCellDef mat-sort-header>Customer Drug Name </th>
                <td [hidden]="!isCustomerDrugName" mat-cell *matCellDef="let element"> {{element.customerDrugName}} </td>
              </ng-container>


              <!-- Product Scan Code Column -->
              <ng-container matColumnDef="productScanCode">
                <th [hidden]="!isProductScanCode" mat-header-cell *matHeaderCellDef> Prod Scan Code </th>
                <td [hidden]="!isProductScanCode" mat-cell *matCellDef="let element"> {{element.productScanCode}} </td>
              </ng-container>

              <!-- GTIN Column -->
              <ng-container matColumnDef="gtin">
                <th [hidden]="!isGtin" mat-header-cell *matHeaderCellDef> GTIN </th>
                <td [hidden]="!isGtin" mat-cell *matCellDef="let element"> {{element.gtin}} </td>
              </ng-container>

              <!-- Pack Size Column -->
              <ng-container matColumnDef="packsize">
                <th [hidden]="!isPacksize" mat-header-cell *matHeaderCellDef> Pack Size </th>
                <td [hidden]="!isPacksize" mat-cell *matCellDef="let element"> {{element.packsize}} </td>
              </ng-container>

              <!-- Purchase Qty Column -->
              <ng-container matColumnDef="purchaseQty">
                <th [hidden]="!isPurchaseQty" mat-header-cell *matHeaderCellDef> Purchase Qty </th>
                <td [hidden]="!isPurchaseQty" mat-cell *matCellDef="let element"> {{element.purchaseQty}} </td>
              </ng-container>

              <!-- Drug Schedule Column -->
              <ng-container matColumnDef="drugSchedule">
                <th [hidden]="!isDrugSchedule" mat-header-cell *matHeaderCellDef> Drug Schedule </th>
                <td [hidden]="!isDrugSchedule" mat-cell *matCellDef="let element"> {{element.drugSchedule}} </td>
              </ng-container>

              <!-- Drug Form Column -->
              <ng-container matColumnDef="drugForm">
                <th [hidden]="!isDrugForm" mat-header-cell *matHeaderCellDef> Drug Form </th>
                <td [hidden]="!isDrugForm" mat-cell *matCellDef="let element"> {{element.drugForm}} </td>
              </ng-container>

              <!-- Drug Form Column -->
              <ng-container matColumnDef="productType">
                <th [hidden]="!isProductType" mat-header-cell *matHeaderCellDef> Product Type </th>
                <td [hidden]="!isProductType" mat-cell *matCellDef="let element"> {{element.productType}} </td>
              </ng-container>

              <!-- UOM Class Column -->
              <ng-container matColumnDef="uomClass">
                <th [hidden]="!isUomClass" mat-header-cell *matHeaderCellDef> UOM Class </th>
                <td [hidden]="!isUomClass" mat-cell *matCellDef="let element"> {{element.uomClass}} </td>
              </ng-container>

              <!-- Sell UOM Column -->
              <ng-container matColumnDef="sellUOM">
                <th [hidden]="!isSellUOM" mat-header-cell *matHeaderCellDef> Sell UOM </th>
                <td [hidden]="!isSellUOM" mat-cell *matCellDef="let element"> {{element.sellUOM}} </td>
              </ng-container>

              <!-- Slot Area Column -->
              <ng-container matColumnDef="slotArea">
                <th [hidden]="!isSlotArea" mat-header-cell *matHeaderCellDef> Slot Area </th>
                <td [hidden]="!isSlotArea" mat-cell *matCellDef="let element"> {{element.slotArea}} </td>
              </ng-container>

              <!-- Slot Shelf Column -->
              <ng-container matColumnDef="slotShelf">
                <th [hidden]="!isSlotShelf" mat-header-cell *matHeaderCellDef> Slot Shelf </th>
                <td [hidden]="!isSlotShelf" mat-cell *matCellDef="let element"> {{element.slotShelf}} </td>
              </ng-container>

              <!-- Slot Bin Column -->
              <ng-container matColumnDef="slotBin">
                <th [hidden]="!isSlotBin" mat-header-cell *matHeaderCellDef> Slot Bin </th>
                <td [hidden]="!isSlotBin" mat-cell *matCellDef="let element"> {{element.slotBin}} </td>
              </ng-container>

              <!-- Loc Type Column -->
              <ng-container matColumnDef="locType">
                <th [hidden]="!isLocType" mat-header-cell *matHeaderCellDef> Loc Type </th>
                <td [hidden]="!isLocType" mat-cell *matCellDef="let element"> {{element.locType}} </td>
              </ng-container>

              <!-- ROP Column -->
              <ng-container matColumnDef="rop">
                <th [hidden]="!isRop" mat-header-cell *matHeaderCellDef> ROP </th>
                <td [hidden]="!isRop" mat-cell *matCellDef="let element"> {{element.rop}} </td>
              </ng-container>

              <!-- Capacity Column -->
              <ng-container matColumnDef="capacity">
                <th [hidden]="!isCapacity" mat-header-cell *matHeaderCellDef> Capacity </th>
                <td [hidden]="!isCapacity" mat-cell *matCellDef="let element"> {{element.capacity}} </td>
              </ng-container>

              <!-- Qty on Shelf Column -->
              <ng-container matColumnDef="qtyonShelf">
                <th [hidden]="!isQtyonShelf" mat-header-cell *matHeaderCellDef> Qty on Shelf </th>
                <td [hidden]="!isQtyonShelf" mat-cell *matCellDef="let element"> {{element.qtyonShelf}} </td>
              </ng-container>

              <!-- Lot No Column -->
              <ng-container matColumnDef="lotNo">
                <th [hidden]="!isLotNo" mat-header-cell *matHeaderCellDef> Lot No </th>
                <td [hidden]="!isLotNo" mat-cell *matCellDef="let element"> {{element.lotNo}} </td>
              </ng-container>

              <!-- Exp Date Column -->
              <ng-container matColumnDef="expDate">
                <th [hidden]="!isExpDate" mat-header-cell *matHeaderCellDef> Exp Date </th>
                <td [hidden]="!isExpDate" mat-cell *matCellDef="let element"> {{element.expDate}} </td>
              </ng-container>

              <!-- Vial Size Column -->
              <ng-container matColumnDef="vialSize">
                <th [hidden]="!isVialSize" mat-header-cell *matHeaderCellDef> Vial Size </th>
                <td [hidden]="!isVialSize" mat-cell *matCellDef="let element"> {{element.vialSize}} </td>
              </ng-container>

              <!-- Vial Capacity Column -->
              <ng-container matColumnDef="vialCapacity">
                <th [hidden]="!isVialCapacity" mat-header-cell *matHeaderCellDef> Vial Capacity </th>
                <td [hidden]="!isVialCapacity" mat-cell *matCellDef="let element"> {{element.vialCapacity}} </td>
              </ng-container>

              <!-- Vial Enabled Column -->
              <ng-container matColumnDef="vialEnabled">
                <th [hidden]="!isVialEnabled" mat-header-cell *matHeaderCellDef> Vial Enabled </th>
                <td [hidden]="!isVialEnabled" mat-cell *matCellDef="let element"> {{element.vialEnabled}} </td>
              </ng-container>

              <!-- VEndor Part No Column -->
              <ng-container matColumnDef="vendorPartNo">
                <th [hidden]="!isVendorPartNo" mat-header-cell *matHeaderCellDef> Vendor Part No </th>
                <td [hidden]="!isVendorPartNo" mat-cell *matCellDef="let element"> {{element.vendorPartNo}} </td>
              </ng-container>

              <!-- Specialty Column -->
              <ng-container matColumnDef="specialty">
                <th [hidden]="!isSpecialty" mat-header-cell *matHeaderCellDef> Specialty </th>
                <td [hidden]="!isSpecialty" mat-cell *matCellDef="let element"> {{element.specialty}} </td>
              </ng-container>

              <!-- ORMD Column -->
              <ng-container matColumnDef="ormd">
                <th [hidden]="!isOrmd" mat-header-cell *matHeaderCellDef> ORMD </th>
                <td [hidden]="!isOrmd" mat-cell *matCellDef="let element"> {{element.ormd}} </td>
              </ng-container>

              <!-- Refrigerate Flag Column -->
              <ng-container matColumnDef="refrigerateFlag">
                <th [hidden]="!isRefrigerateFlag" mat-header-cell *matHeaderCellDef> Refrigerate Flag </th>
                <td [hidden]="!isRefrigerateFlag" mat-cell *matCellDef="let element"> {{element.refrigerateFlag}} </td>
              </ng-container>

              <!-- Rank Column -->
              <ng-container matColumnDef="rank">
                <th [hidden]="!isRank" mat-header-cell *matHeaderCellDef> Rank </th>
                <td [hidden]="!isRank" mat-cell *matCellDef="let element"> {{element.rank}} </td>
              </ng-container>

              <!-- # of Rxs Column -->
              <ng-container matColumnDef="rxQty">
                <th [hidden]="!isRxQty" mat-header-cell *matHeaderCellDef> # of Rxs </th>
                <td [hidden]="!isRxQty" mat-cell *matCellDef="let element"> {{element.rxQty}} </td>
              </ng-container>

              <!-- # of Units Column -->
              <ng-container matColumnDef="usage">
                <th [hidden]="!isUsage" mat-header-cell *matHeaderCellDef> # of Units </th>
                <td [hidden]="!isUsage" mat-cell *matCellDef="let element"> {{element.usage}} </td>
              </ng-container>

              <!-- 30 Dram Column -->
              <ng-container matColumnDef="thirtyDramCapacity">
                <th [hidden]="!isThirtyDramCapacity" mat-header-cell *matHeaderCellDef mat-sort-header> 30 Dram </th>
                <td [hidden]="!isThirtyDramCapacity" mat-cell *matCellDef="let element"> {{element.thirtyDramCapacity}}</td>
              </ng-container>

              <!-- Max Recommended For Use Column -->
              <ng-container matColumnDef="maxRecommendedForUse">
                <th [hidden]="!isMaxRecommendedForUse" mat-header-cell *matHeaderCellDef mat-sort-header> Max Recommended For Use </th>
                <td [hidden]="!isMaxRecommendedForUse" mat-cell *matCellDef="let element"> {{element.maxRecomendedforUse}}</td>
              </ng-container>

              <!-- Is Oral Solid Column -->
              <ng-container matColumnDef="isOralSolid">
                <th [hidden]="!isOralsolid" mat-header-cell *matHeaderCellDef mat-sort-header> Is Oral Solid </th>
                <td [hidden]="!isOralsolid" mat-cell *matCellDef="let element"> {{element.isOralSolid}}</td>
              </ng-container>

              <!-- Cell Capacity Small Column -->
              <ng-container matColumnDef="cellCapacitySmall">
                <th [hidden]="!isCellCapacitySmall" mat-header-cell *matHeaderCellDef mat-sort-header> Cell Capacity Small </th>
                <td [hidden]="!isCellCapacitySmall" mat-cell *matCellDef="let element"> {{element.cellCapacitySmall}}</td>
              </ng-container>

              <!-- Cell Capacity Large Column -->
              <ng-container matColumnDef="cellCapacityLarge">
                <th [hidden]="!isCellCapacityLarge" mat-header-cell *matHeaderCellDef mat-sort-header> Cell Capacity Large </th>
                <td [hidden]="!isCellCapacityLarge" mat-cell *matCellDef="let element"> {{element.cellCapacityLarge}}</td>
              </ng-container>

              <!-- NA Column -->
              <ng-container matColumnDef="na">
                <th [hidden]="!isNA" mat-header-cell *matHeaderCellDef mat-sort-header> NA </th>
                <td [hidden]="!isNA" mat-cell *matCellDef="let element"> {{element.na}}</td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-icon [matMenuTriggerFor]="columnMenu" class="pointer menu-trigger" tabindex="0" style="margin: 0px 0px 0px 15px">
                    <img src="/assets/img/icons/ico.16.edit.svg" alt="">
                  </mat-icon>
                  <mat-menu #columnMenu="matMenu" backdropClass="custom_drop" xPosition="after">
                    <div class="checkbox-container">
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isProductId">
                        Product ID
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isNDC">
                        NDC
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isDrugName">
                        CDDB Drug Name
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isCustomerDrugName">
                        Customer Drug Name
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isGtin">
                        GTIN
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isRank">
                        Rank
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isThirtyDramCapacity">
                        30 Dram
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isProductScanCode">
                        Product Scan Code
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isPacksize">
                        Pack Size
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isPurchaseQty" class="table-dynamic-column flex-row">
                        Purchase Qty
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isDrugSchedule" class="table-dynamic-column flex-row">
                        Drug Schedule
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isDrugForm" class="table-dynamic-column flex-row">
                        Drug Form
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isProductType" class="table-dynamic-column flex-row">
                        Product Type
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isUomClass" class="table-dynamic-column flex-row">
                        UOM Class
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSellUOM" class="table-dynamic-column flex-row">
                        Sell UOM
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSlotArea" class="table-dynamic-column flex-row">
                        Slot Area
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSlotShelf" class="table-dynamic-column flex-row">
                        Slot Shelf
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSlotBin" class="table-dynamic-column flex-row">
                        Slot Bin
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isLocType" class="table-dynamic-column flex-row">
                        Loc Type
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isRop" class="table-dynamic-column flex-row">
                        ROP
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isCapacity" class="table-dynamic-column flex-row">
                        Capacity
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isQtyonShelf" class="table-dynamic-column flex-row">
                        Is Qty on Shelf
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isLotNo" class="table-dynamic-column flex-row">
                        Lot No
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isExpDate" class="table-dynamic-column flex-row">
                        Exp Date
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isVialSize" class="table-dynamic-column flex-row">
                        Vial Size
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isVialCapacity" class="table-dynamic-column flex-row">
                        Vial Capacity
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isVialEnabled" class="table-dynamic-column flex-row">
                        Vial Enabled
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isVendorPartNo" class="table-dynamic-column flex-row">
                        Vendor Part No
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSpecialty" class="table-dynamic-column flex-row">
                        Specialty
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isOrmd" class="table-dynamic-column flex-row">
                        ORMD
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isRefrigerateFlag" class="table-dynamic-column flex-row">
                        Refrigerate Flag
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isRxQty" class="table-dynamic-column flex-row">
                        Rx Qty
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isUsage" class="table-dynamic-column flex-row">
                        Usage
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isMaxRecommendedForUse" class="table-dynamic-column flex-row">
                        Max Recommended For Use
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isOralsolid" class="table-dynamic-column flex-row">
                        Oral Solid
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isCellCapacitySmall" class="table-dynamic-column flex-row">
                        Cell Capacity Small
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isCellCapacityLarge" class="table-dynamic-column flex-row">
                        Cell Capacity Large
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isNA" class="table-dynamic-column flex-row">
                        NA
                      </mat-checkbox>

                    </div>
                    <button style="margin: 1% 1% 5% 20%; height: 30px;" class="table-dynamic-column btn btn-primary btn-sm">Ok</button>
                  </mat-menu>
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: right;">
                  <mat-icon class="pointer menu-trigger" tabindex="0" style=" margin: 0px 20px 0px 0px">
                    <img src="/assets/img/icons/ico_16_Menu.svg" alt="">
                  </mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr (click)="selectedRow = row" [ngClass]="{ 'highlight': row === selectedRow }" (mouseenter)="selectedRow = row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>

            <table>
              <tr *ngIf="dataSource.data.length==0">
                <td style="text-align: center;" [attr.colspan]="displayedColumns.length">
                  No Records Found!
                </td>
              </tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab label="Excluded({{dataSourceExcluded.data.length}})">
          <div class="mat-elevation-z8" #TABLE1>
            <table mat-table #table1 class="mat-elevation-z8" [dataSource]="dataSourceExcluded" matSort>

              <!-- Product ID Column -->
              <ng-container matColumnDef="productId">
                <th [hidden]="!isProductIdExcluded" mat-header-cell *matHeaderCellDef mat-sort-header> Product ID </th>
                <td [hidden]="!isProductIdExcluded" mat-cell *matCellDef="let element"> {{element.productID}} </td>
              </ng-container>

              <!--NDC column-->
              <ng-container matColumnDef="ndc">
                <th [hidden]="!isNDCExcluded" mat-header-cell *matHeaderCellDef mat-sort-header> NDC </th>
                <td [hidden]="!isNDCExcluded" mat-cell *matCellDef="let element"> {{element.ndc}} </td>
              </ng-container>

              <!-- excludedReason Column -->
              <ng-container matColumnDef="excludedReason">
                <th mat-header-cell *matHeaderCellDef> Excluded Reason </th>
                <td mat-cell *matCellDef="let element"> {{element.excludedReason}} </td>
              </ng-container>

              <!-- Drug Name Column -->
              <ng-container matColumnDef="drugName">
                <th [hidden]="!isDrugNameExcluded" mat-header-cell *matHeaderCellDef mat-sort-header>CDDB Drug Name </th>
                <td [hidden]="!isDrugNameExcluded" mat-cell *matCellDef="let element"> {{element.drugName}} </td>
              </ng-container>

              <!-- Customer Drug Name Column -->
              <ng-container matColumnDef="customerDrugName">
                <th [hidden]="!isCustomerDrugNameExcluded" mat-header-cell *matHeaderCellDef mat-sort-header>Customer Drug Name </th>
                <td [hidden]="!isCustomerDrugNameExcluded" mat-cell *matCellDef="let element"> {{element.customerDrugName}} </td>
              </ng-container>


              <!-- Product Scan Code Column -->
              <ng-container matColumnDef="productScanCode">
                <th [hidden]="!isProductScanCodeExcluded" mat-header-cell *matHeaderCellDef> Prod Scan Code </th>
                <td [hidden]="!isProductScanCodeExcluded" mat-cell *matCellDef="let element"> {{element.productScanCode}} </td>
              </ng-container>

              <!-- GTIN Column -->
              <ng-container matColumnDef="gtin">
                <th [hidden]="!isGtinExcluded" mat-header-cell *matHeaderCellDef> GTIN </th>
                <td [hidden]="!isGtinExcluded" mat-cell *matCellDef="let element"> {{element.gtin}} </td>
              </ng-container>

              <!-- Pack Size Column -->
              <ng-container matColumnDef="packsize">
                <th [hidden]="!isPacksizeExcluded" mat-header-cell *matHeaderCellDef> Pack Size </th>
                <td [hidden]="!isPacksizeExcluded" mat-cell *matCellDef="let element"> {{element.packsize}} </td>
              </ng-container>

              <!-- Purchase Qty Column -->
              <ng-container matColumnDef="purchaseQty">
                <th [hidden]="!isPurchaseQtyExcluded" mat-header-cell *matHeaderCellDef> Purchase Qty </th>
                <td [hidden]="!isPurchaseQtyExcluded" mat-cell *matCellDef="let element"> {{element.purchaseQty}} </td>
              </ng-container>

              <!-- Drug Schedule Column -->
              <ng-container matColumnDef="drugSchedule">
                <th [hidden]="!isDrugScheduleExcluded" mat-header-cell *matHeaderCellDef> Drug Schedule </th>
                <td [hidden]="!isDrugScheduleExcluded" mat-cell *matCellDef="let element"> {{element.drugSchedule}} </td>
              </ng-container>

              <!-- Drug Form Column -->
              <ng-container matColumnDef="drugForm">
                <th [hidden]="!isDrugFormExcluded" mat-header-cell *matHeaderCellDef> Drug Form </th>
                <td [hidden]="!isDrugFormExcluded" mat-cell *matCellDef="let element"> {{element.drugForm}} </td>
              </ng-container>

              <!-- Drug Form Column -->
              <ng-container matColumnDef="productType">
                <th [hidden]="!isProductTypeExcluded" mat-header-cell *matHeaderCellDef> Product Type </th>
                <td [hidden]="!isProductTypeExcluded" mat-cell *matCellDef="let element"> {{element.productType}} </td>
              </ng-container>

              <!-- UOM Class Column -->
              <ng-container matColumnDef="uomClass">
                <th [hidden]="!isUomClassExcluded" mat-header-cell *matHeaderCellDef> UOM Class </th>
                <td [hidden]="!isUomClassExcluded" mat-cell *matCellDef="let element"> {{element.uomClass}} </td>
              </ng-container>

              <!-- Sell UOM Column -->
              <ng-container matColumnDef="sellUOM">
                <th [hidden]="!isSellUOMExcluded" mat-header-cell *matHeaderCellDef> Sell UOM </th>
                <td [hidden]="!isSellUOMExcluded" mat-cell *matCellDef="let element"> {{element.sellUOM}} </td>
              </ng-container>

              <!-- Slot Area Column -->
              <ng-container matColumnDef="slotArea">
                <th [hidden]="!isSlotAreaExcluded" mat-header-cell *matHeaderCellDef> Slot Area </th>
                <td [hidden]="!isSlotAreaExcluded" mat-cell *matCellDef="let element"> {{element.slotArea}} </td>
              </ng-container>

              <!-- Slot Shelf Column -->
              <ng-container matColumnDef="slotShelf">
                <th [hidden]="!isSlotShelfExcluded" mat-header-cell *matHeaderCellDef> Slot Shelf </th>
                <td [hidden]="!isSlotShelfExcluded" mat-cell *matCellDef="let element"> {{element.slotShelf}} </td>
              </ng-container>

              <!-- Slot Bin Column -->
              <ng-container matColumnDef="slotBin">
                <th [hidden]="!isSlotBinExcluded" mat-header-cell *matHeaderCellDef> Slot Bin </th>
                <td [hidden]="!isSlotBinExcluded" mat-cell *matCellDef="let element"> {{element.slotBin}} </td>
              </ng-container>

              <!-- Loc Type Column -->
              <ng-container matColumnDef="locType">
                <th [hidden]="!isLocTypeExcluded" mat-header-cell *matHeaderCellDef> Loc Type </th>
                <td [hidden]="!isLocTypeExcluded" mat-cell *matCellDef="let element"> {{element.locType}} </td>
              </ng-container>

              <!-- ROP Column -->
              <ng-container matColumnDef="rop">
                <th [hidden]="!isRopExcluded" mat-header-cell *matHeaderCellDef> ROP </th>
                <td [hidden]="!isRopExcluded" mat-cell *matCellDef="let element"> {{element.rop}} </td>
              </ng-container>

              <!-- Capacity Column -->
              <ng-container matColumnDef="capacity">
                <th [hidden]="!isCapacityExcluded" mat-header-cell *matHeaderCellDef> Capacity </th>
                <td [hidden]="!isCapacityExcluded" mat-cell *matCellDef="let element"> {{element.capacity}} </td>
              </ng-container>

              <!-- Qty on Shelf Column -->
              <ng-container matColumnDef="qtyonShelf">
                <th [hidden]="!isQtyonShelfExcluded" mat-header-cell *matHeaderCellDef> Qty on Shelf </th>
                <td [hidden]="!isQtyonShelfExcluded" mat-cell *matCellDef="let element"> {{element.qtyonShelf}} </td>
              </ng-container>

              <!-- Lot No Column -->
              <ng-container matColumnDef="lotNo">
                <th [hidden]="!isLotNoExcluded" mat-header-cell *matHeaderCellDef> Lot No </th>
                <td [hidden]="!isLotNoExcluded" mat-cell *matCellDef="let element"> {{element.lotNo}} </td>
              </ng-container>

              <!-- Exp Date Column -->
              <ng-container matColumnDef="expDate">
                <th [hidden]="!isExpDateExcluded" mat-header-cell *matHeaderCellDef> Exp Date </th>
                <td [hidden]="!isExpDateExcluded" mat-cell *matCellDef="let element"> {{element.expDate}} </td>
              </ng-container>

              <!-- Vial Size Column -->
              <ng-container matColumnDef="vialSize">
                <th [hidden]="!isVialSizeExcluded" mat-header-cell *matHeaderCellDef> Vial Size </th>
                <td [hidden]="!isVialSizeExcluded" mat-cell *matCellDef="let element"> {{element.vialSize}} </td>
              </ng-container>

              <!-- Vial Capacity Column -->
              <ng-container matColumnDef="vialCapacity">
                <th [hidden]="!isVialCapacityExcluded" mat-header-cell *matHeaderCellDef> Vial Capacity </th>
                <td [hidden]="!isVialCapacityExcluded" mat-cell *matCellDef="let element"> {{element.vialCapacity}} </td>
              </ng-container>

              <!-- Vial Enabled Column -->
              <ng-container matColumnDef="vialEnabled">
                <th [hidden]="!isVialEnabledExcluded" mat-header-cell *matHeaderCellDef> Vial Enabled </th>
                <td [hidden]="!isVialEnabledExcluded" mat-cell *matCellDef="let element"> {{element.vialEnabled}} </td>
              </ng-container>

              <!-- VEndor Part No Column -->
              <ng-container matColumnDef="vendorPartNo">
                <th [hidden]="!isVendorPartNoExcluded" mat-header-cell *matHeaderCellDef> Vendor Part No </th>
                <td [hidden]="!isVendorPartNoExcluded" mat-cell *matCellDef="let element"> {{element.vendorPartNo}} </td>
              </ng-container>

              <!-- Specialty Column -->
              <ng-container matColumnDef="specialty">
                <th [hidden]="!isSpecialtyExcluded" mat-header-cell *matHeaderCellDef> Specialty </th>
                <td [hidden]="!isSpecialtyExcluded" mat-cell *matCellDef="let element"> {{element.specialty}} </td>
              </ng-container>

              <!-- ORMD Column -->
              <ng-container matColumnDef="ormd">
                <th [hidden]="!isOrmdExcluded" mat-header-cell *matHeaderCellDef> ORMD </th>
                <td [hidden]="!isOrmdExcluded" mat-cell *matCellDef="let element"> {{element.ormd}} </td>
              </ng-container>

              <!-- Refrigerate Flag Column -->
              <ng-container matColumnDef="refrigerateFlag">
                <th [hidden]="!isRefrigerateFlagExcluded" mat-header-cell *matHeaderCellDef> Refrigerate Flag </th>
                <td [hidden]="!isRefrigerateFlagExcluded" mat-cell *matCellDef="let element"> {{element.refrigerateFlag}} </td>
              </ng-container>

              <!-- Rank Column -->
              <ng-container matColumnDef="rank">
                <th [hidden]="!isRankExcluded" mat-header-cell *matHeaderCellDef> Rank </th>
                <td [hidden]="!isRankExcluded" mat-cell *matCellDef="let element"> {{element.rank}} </td>
              </ng-container>

              <!-- # of Rxs Column -->
              <ng-container matColumnDef="rxQty">
                <th [hidden]="!isRxQtyExcluded" mat-header-cell *matHeaderCellDef> # of Rxs </th>
                <td [hidden]="!isRxQtyExcluded" mat-cell *matCellDef="let element"> {{element.rxQty}} </td>
              </ng-container>

              <!-- # of Units Column -->
              <ng-container matColumnDef="usage">
                <th [hidden]="!isUsageExcluded" mat-header-cell *matHeaderCellDef> # of Units </th>
                <td [hidden]="!isUsageExcluded" mat-cell *matCellDef="let element"> {{element.usage}} </td>
              </ng-container>

              <!-- 30 Dram Column -->
              <ng-container matColumnDef="thirtyDramCapacity">
                <th [hidden]="!isThirtyDramCapacityExcluded" mat-header-cell *matHeaderCellDef mat-sort-header> 30 Dram </th>
                <td [hidden]="!isThirtyDramCapacityExcluded" mat-cell *matCellDef="let element"> {{element.thirtyDramCapacity}}</td>
              </ng-container>

              <!-- Max Recommended For Use Column -->
              <ng-container matColumnDef="maxRecommendedForUse">
                <th [hidden]="!isMaxRecommendedForUseExcluded" mat-header-cell *matHeaderCellDef mat-sort-header> Max Recommended For Use </th>
                <td [hidden]="!isMaxRecommendedForUseExcluded" mat-cell *matCellDef="let element"> {{element.maxRecomendedforUse}}</td>
              </ng-container>

              <!-- Is Oral Solid Column -->
              <ng-container matColumnDef="isOralSolid">
                <th [hidden]="!isOralsolidExcluded" mat-header-cell *matHeaderCellDef mat-sort-header> Is Oral Solid </th>
                <td [hidden]="!isOralsolidExcluded" mat-cell *matCellDef="let element"> {{element.isOralSolid}}</td>
              </ng-container>

              <!-- Cell Capacity Small Column -->
              <ng-container matColumnDef="cellCapacitySmall">
                <th [hidden]="!isCellCapacitySmallExcluded" mat-header-cell *matHeaderCellDef mat-sort-header> Cell Capacity Small </th>
                <td [hidden]="!isCellCapacitySmallExcluded" mat-cell *matCellDef="let element"> {{element.cellCapacitySmall}}</td>
              </ng-container>

              <!-- Cell Capacity Large Column -->
              <ng-container matColumnDef="cellCapacityLarge">
                <th [hidden]="!isCellCapacityLargeExcluded" mat-header-cell *matHeaderCellDef mat-sort-header> Cell Capacity Large </th>
                <td [hidden]="!isCellCapacityLargeExcluded" mat-cell *matCellDef="let element"> {{element.cellCapacityLarge}}</td>
              </ng-container>

              <!-- NA Column -->
              <ng-container matColumnDef="na">
                <th [hidden]="!isNAExcluded" mat-header-cell *matHeaderCellDef mat-sort-header> NA </th>
                <td [hidden]="!isNAExcluded" mat-cell *matCellDef="let element"> {{element.na}}</td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-icon [matMenuTriggerFor]="columnMenu" class="pointer menu-trigger" tabindex="0" style="margin: 0px 0px 0px 15px">
                    <img src="/assets/img/icons/ico.16.edit.svg" alt="">
                  </mat-icon>
                  <mat-menu #columnMenu="matMenu" backdropClass="custom_drop" xPosition="after">
                    <div class="checkbox-container">
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isProductIdExcluded">
                        Product ID
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isNDCExcluded">
                        NDC
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isDrugNameExcluded">
                        CDDB Drug Name
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isCustomerDrugNameExcluded">
                        Customer Drug Name
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isGtinExcluded">
                        GTIN
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isRankExcluded">
                        Rank
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isThirtyDramCapacityExcluded">
                        30 Dram
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isProductScanCodeExcluded">
                        Product Scan Code
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    class="table-dynamic-column flex-row" [(ngModel)]="isPacksizeExcluded">
                        Pack Size
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isPurchaseQtyExcluded" class="table-dynamic-column flex-row">
                        Purchase Qty
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isDrugScheduleExcluded" class="table-dynamic-column flex-row">
                        Drug Schedule
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isDrugFormExcluded" class="table-dynamic-column flex-row">
                        Drug Form
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isProductTypeExcluded" class="table-dynamic-column flex-row">
                        Product Type
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isUomClassExcluded" class="table-dynamic-column flex-row">
                        UOM Class
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSellUOMExcluded" class="table-dynamic-column flex-row">
                        Sell UOM
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSlotAreaExcluded" class="table-dynamic-column flex-row">
                        Slot Area
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSlotShelfExcluded" class="table-dynamic-column flex-row">
                        Slot Shelf
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSlotBinExcluded" class="table-dynamic-column flex-row">
                        Slot Bin
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isLocTypeExcluded" class="table-dynamic-column flex-row">
                        Loc Type
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isRopExcluded" class="table-dynamic-column flex-row">
                        ROP
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isCapacityExcluded" class="table-dynamic-column flex-row">
                        Capacity
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isQtyonShelfExcluded" class="table-dynamic-column flex-row">
                        Is Qty on Shelf
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isLotNoExcluded" class="table-dynamic-column flex-row">
                        Lot No
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isExpDateExcluded" class="table-dynamic-column flex-row">
                        Exp Date
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isVialSizeExcluded" class="table-dynamic-column flex-row">
                        Vial Size
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isVialCapacityExcluded" class="table-dynamic-column flex-row">
                        Vial Capacity
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isVialEnabledExcluded" class="table-dynamic-column flex-row">
                        Vial Enabled
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isVendorPartNoExcluded" class="table-dynamic-column flex-row">
                        Vendor Part No
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isSpecialtyExcluded" class="table-dynamic-column flex-row">
                        Specialty
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isOrmdExcluded" class="table-dynamic-column flex-row">
                        ORMD
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isRefrigerateFlagExcluded" class="table-dynamic-column flex-row">
                        Refrigerate Flag
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isRxQtyExcluded" class="table-dynamic-column flex-row">
                        Rx Qty
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isUsageExcluded" class="table-dynamic-column flex-row">
                        Usage
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isMaxRecommendedForUseExcluded" class="table-dynamic-column flex-row">
                        Max Recommended For Use
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isOralsolidExcluded" class="table-dynamic-column flex-row">
                        Oral Solid
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isCellCapacitySmallExcluded" class="table-dynamic-column flex-row">
                        Cell Capacity Small
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isCellCapacityLargeExcluded" class="table-dynamic-column flex-row">
                        Cell Capacity Large
                      </mat-checkbox>
                      <mat-checkbox (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()"
                                    [(ngModel)]="isNAExcluded" class="table-dynamic-column flex-row">
                        NA
                      </mat-checkbox>

                    </div>
                    <button style="margin: 1% 1% 5% 20%; height: 30px;" class="table-dynamic-column btn btn-primary btn-sm">Ok</button>
                  </mat-menu>
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: right;">
                  <mat-icon class="pointer menu-trigger" tabindex="0" style=" margin: 0px 20px 0px 0px">
                    <img src="/assets/img/icons/ico_16_Menu.svg" alt="">
                  </mat-icon>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumnsExcluded"></tr>
              <tr (click)="selectedRow = row" [ngClass]="{ 'highlight': row === selectedRow }" mat-row *matRowDef="let row; columns: displayedColumnsExcluded;"></tr>


            </table>
            <table>
              <tr *ngIf="dataSourceExcluded.data.length==0">
                <td style="text-align: center;" [attr.colspan]="displayedColumnsExcluded.length">
                  No Records Found!
                </td>
              </tr>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </section>
</app-card>
